var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Type } from './Type';
import { FixedInt } from './FixedInt';
var ObjectId = /** @class */ (function (_super) {
    __extends(ObjectId, _super);
    function ObjectId() {
        var _this = _super.call(this) || this;
        _this._fixedInt = new FixedInt(2);
        return _this;
    }
    ObjectId.prototype.encodeBuffer = function (hex, buffer) {
        hex = String(hex);
        if (!/^[0-9a-f]{24}$/.test(hex)) {
            throw new TypeError('MongoDB Object id must be 24 hex symbols, but received ' + hex);
        }
        var fixedInt = this._fixedInt;
        // @ts-ignore
        hex.replace(/.../g, function (part) {
            // @ts-ignore
            fixedInt.encodeBuffer(parseInt(part, 16), buffer);
        });
    };
    ObjectId.prototype.decodeBuffer = function (buffer) {
        var hexParts = [];
        for (var i = 0; i < 8; i++) {
            var part = this._fixedInt.decodeBuffer(buffer).toString(16);
            while (part.length < 3) {
                part = '0' + part;
            }
            hexParts.push(part);
        }
        return hexParts.join('');
    };
    return ObjectId;
}(Type));
export { ObjectId };
